import $ from 'jquery';
import progress from '../../utils/progress';
import validator from '../../utils/validator';
import {initPreferenceCenterEvents} from '../../components/preferencecenter';
import initCustomSelect from '../../components/custom-select';
import {attachOnTouched} from '../../widgets/friendlyCaptcha';
import {resetCaptcha} from '../../spam/captcha';
import {createAccountSlider} from './components/accountslider';

let formIsBeingSubmitted = false;

/**
 * Displays error in case newsletter terms are not accepted
 *
 * @param {jQuery} $newsletterContainer  - newsletter container
 */
const showTermsError = $newsletterContainer => {
    const $termsContainer = $newsletterContainer.find('.terms-small');
    $termsContainer.addClass('validation-error');
    $(
        `<div class="status newsletter-account message error-form">${$newsletterContainer.data(
            'terms-not-accepted-msg'
        )}</div>`
    ).insertBefore($termsContainer);

    $termsContainer.one('click', () => {
        $termsContainer.prev('.status').fadeOut(300, () => $termsContainer.removeClass('validation-error'));
    });
};

/**
 *  Handles subscription/unsubscription process in my account via AJAX
 *
 * @param {jQuery} $form - form
 * @param {jQuery} $submitButton - form submit button
 */
const handleSettingsForm = ($form, $submitButton) => {
    const $newsletterContainer = $form.closest('.account-nl-container');
    $newsletterContainer.find('.status').remove();
    const hasAcceptedTerms =
        $form.find('.js-accept-terms-hidden').length > 0
            ? true
            : $form.find('.terms-small .checkbox-input').prop('checked');
    const action = $submitButton.attr('id');

    if ((action === 'subscribe' || action === 'subscribeSMS') && !hasAcceptedTerms) {
        showTermsError($newsletterContainer);
        return;
    }

    if (action === 'subscribeSMS' && !$form.valid()) {
        return;
    }

    formIsBeingSubmitted = true;
    $submitButton.prop('disabled', true);
    progress.show($form);

    const data = {
        action,
        acceptterms: hasAcceptedTerms
    };

    $form.serializeArray().forEach(formData => (data[formData.name] = formData.value));

    $.ajax({
        url: $form.attr('action'),
        method: 'POST',
        dataType: 'json',
        data,
        /**
         * Asynchronous request success state
         *
         * @param {Object} response response data
         */
        success: response => {
            formIsBeingSubmitted = false;
            $submitButton.prop('disabled', false);
            let {msg} = response;
            if (response.success) {
                if (action === 'subscribe' || action === 'subscribeSMS') {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSignup_accountSettings',
                            newsletterSignupStep: 'AccountSettings'
                        });
                    }

                    $('.newsletter-benefits-container').hide();
                    $newsletterContainer.find('.terms-small').hide();
                    if (response.subscribedText) {
                        $newsletterContainer
                            .find('.newsletter-status-text')
                            .removeClass('not-subscribed')
                            .addClass('subscribed')
                            .html(response.subscribedText);
                    }
                }

                if (action === 'unsubscribe' && response.subscribedText) {
                    $newsletterContainer
                        .find('.newsletter-status-text')
                        .removeClass('subscribed')
                        .addClass('not-subscribed')
                        .html(response.subscribedText);
                }

                $form.find('.form-row.validation-error').removeClass('validation-error');
                $form.find('.set-subscribe-status').fadeOut();
                $form.find('.newsletter-optout').fadeOut();
                $(`<div class="status newsletter-account message success-form">${msg}</div>`)
                    .insertAfter($newsletterContainer.find('.account-nl-action'))
                    .addClass('message-no-icon');

                if (response.socialContent) {
                    $(response.socialContent).insertAfter($newsletterContainer.parents('.newsletter-settings'));
                }

                const subscribedEvent = document.createEvent('CustomEvent');
                subscribedEvent.initCustomEvent('customer.subscriptionChanged', true, false, {
                    optInType: response.optInType,
                    action
                });
                window.dispatchEvent(subscribedEvent);
            } else if (response.error) {
                $form.find('.form-row.validation-error').removeClass('validation-error');
                $(`<div class="status newsletter-account message error-form">${msg}</div>`).insertBefore(
                    $newsletterContainer.find('.nlsubscribe-form .terms-small')
                );
                resetCaptcha($form[0]);
            } else if (response.formerror) {
                msg = $newsletterContainer.data('terms-not-accepted-msg');
                $form.find('.form-row.validation-error').removeClass('validation-error');
                $(`<div class="status newsletter-account message error-form">${msg}</div>`).insertBefore(
                    $newsletterContainer.find('.nlsubscribe-form .terms-small')
                );
                resetCaptcha($form[0]);
            }
        },
        /**
         * Asynchronous request error state
         */
        error: () => {
            formIsBeingSubmitted = false;
            $submitButton.prop('disabled', false);
            const message = $newsletterContainer.data('error-msg');
            $form.find('.form-row.validation-error').removeClass('validation-error');
            $(`<div class="status newsletter-account message error-form">${message}</div>`).insertBefore(
                $newsletterContainer.find('.nlsubscribe-form .terms-small')
            );
            resetCaptcha($form[0]);
        },
        /**
         * Request finished callback
         *
         * @returns {void}
         */
        complete: () => progress.hide()
    });
};

/**
 *  Handles subscription pause/unpause process in my account via AJAX
 *
 * @param {jQuery} $form - from
 * @param {jQuery} $pauseButton - from pause button
 */
const handlePause = ($form, $pauseButton) => {
    const $newsletterContainer = $form.closest('.account-nl-container');
    const $acceptTermsCheckbox = $form.find('.terms-small .checkbox-input');
    const $acceptTermsHidden = $('.js-accept-terms-hidden');
    const mustAcceptTerms = $acceptTermsHidden.length || $acceptTermsCheckbox.length;
    let hasAcceptedTerms = $acceptTermsHidden.length > 0;
    if (!hasAcceptedTerms) {
        hasAcceptedTerms = $acceptTermsCheckbox.prop('checked');
    }
    $newsletterContainer.find('.status').remove();

    if (mustAcceptTerms && !hasAcceptedTerms) {
        showTermsError($newsletterContainer);
        return;
    }

    formIsBeingSubmitted = true;
    $pauseButton.prop('disabled', true);
    progress.show($form);

    const action = $pauseButton.attr('value');
    $.ajax({
        dataType: 'json',
        method: 'post',
        data: {
            action
        },
        url: $pauseButton.data('url'),
        /**
         * Asynchronous request success state
         *
         * @param {Object} response response data
         */
        success: response => {
            formIsBeingSubmitted = false;
            const {message} = response;

            if (response.success) {
                if (action === 'unpause') {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSignup',
                            newsletterSignupStep: 'AccountSettings'
                        });
                    }

                    $('.newsletter-benefits-container').hide();
                    $newsletterContainer.find('.terms-small').hide();

                    if (response.subscribedText) {
                        $newsletterContainer
                            .find('.newsletter-status-text')
                            .removeClass('paused')
                            .addClass('subscribed')
                            .html(response.subscribedText);
                    }
                }

                if (action === 'pause' && response.subscribedText) {
                    $newsletterContainer
                        .find('.newsletter-status-text')
                        .removeClass('subscribed')
                        .addClass('paused')
                        .html(response.subscribedText);
                }

                $newsletterContainer.find('.form-row').removeClass('validation-error');
                $newsletterContainer.find('.set-subscribe-status').hide();
                $newsletterContainer.find('.newsletter-optout').hide();
                $(`<div class="status newsletter-account message success-form">${message}</div>`)
                    .insertAfter($newsletterContainer.find('.account-nl-action'))
                    .addClass('message-no-icon');
            } else {
                $newsletterContainer.find('.form-row').removeClass('validation-error');
                $(`<div class="status newsletter-account message error-form">${message}</div>`).insertBefore(
                    '.nlsubscribe-form .terms-small'
                );
            }
            progress.hide();
        },
        /**
         * Asynchronous request error state
         */
        error: () => {
            formIsBeingSubmitted = false;
            $pauseButton.prop('disabled', false);
            const message = $newsletterContainer.data('error-msg');
            $('div[id$=newsletter_acceptterms]').closest('.form-row').addClass('validation-error');
            $(`<div class="status newsletter-account message error-form">${message}</div>`).insertBefore(
                $newsletterContainer.find('.nlsubscribe-form .terms-small')
            );
            progress.hide();
        }
    });
};

/**
 * @private
 * @function
 * @description Initializes events on NL elements on account page.
 */
const initializeEvents = () => {
    const $newsletterContainer = $('.account-nl-container:not(.preference-center-main)');
    $newsletterContainer.on('click', 'button[type="submit"]', e => {
        e.preventDefault();
        if (formIsBeingSubmitted) {
            return;
        }
        const $submitButton = $(e.currentTarget);
        const $form = $submitButton.closest('form');

        handleSettingsForm($form, $submitButton);
    });

    const $pauseButton = $('.nl-pause-toggle');
    $pauseButton.on('click', e => {
        e.preventDefault();
        if (formIsBeingSubmitted) {
            return;
        }
        const $form = $pauseButton.closest('form');
        handlePause($form, $pauseButton);
    });

    const elementToAttach = $('#dwfrm_newsletter_acceptterms');

    attachOnTouched('.nlsubscribe-form .frc-captcha', elementToAttach);
};

/**
 * @private
 * @function
 * @description Initializes the newsletter benefits slider
 */
const initNewsletterSlider = () => {
    const $benefitsContainer = $('.pt_account .newsletter-benefits .container');
    const $benefits = $benefitsContainer.find('.element');
    const $benefitsExtraText = $('.newsletter-benefits .benefits-extra-text');
    const autoplaySpeed = $('.newsletter-benefits').data('autoplay-speed');

    createAccountSlider($benefitsContainer, {
        autoplaySpeed: autoplaySpeed * 1000 || 5000
    });
    $benefitsExtraText.find(`.${$benefits.first().data('benefit')}`).addClass('shown');

    $benefitsContainer.on('afterChange', () => {
        $benefitsExtraText.find('p:visible').removeClass('shown');
        $('.slick-active').each((index, slide) => {
            const element = $(slide).find('.element');
            $benefitsExtraText.find(`.${element.data('benefit')}`).addClass('shown');
        });
    });
};

/* eslint-disable import/prefer-default-export */
/**
 * Initializes the newsletter page components and events.
 */
export const init = () => {
    initializeEvents();
    initNewsletterSlider();
    initPreferenceCenterEvents();
    initCustomSelect();

    validator.init();
};
